import { IconWarning } from '../../../assets/DesignSystem/SVGComponents';
import NudosButton from '../NudosButton/NudosButton';
import { ReactNode } from 'react';
import './NudosConfirmActionModal.scss';

const NudosConfirmActionModalContent = ({
  modalTitle,
  modalText,
  firstButtonText,
  secondButtonText,
  firstButtonAction,
  secondButtonAction,
  isLoading,
  customHeight,
  customMarginTopContainerButtons = '',
  customStyleModalTitle
}: {
  modalTitle?: string;
  modalText: string | ReactNode;
  firstButtonText: string;
  secondButtonText: string;
  firstButtonAction: () => void;
  secondButtonAction: () => void;
  isLoading?: boolean;
  customHeight?: string;
  customMarginTopContainerButtons?: string;
  customStyleModalTitle?: React.CSSProperties;
}) => {
  return (
    <div className="nudosConfirmActionModal" style={{ height: customHeight }}>
      <div className="iconContainer">
        <IconWarning className="iconWarning" />
      </div>
      {modalTitle && <div className="modalTitle" style={customStyleModalTitle}>{modalTitle}</div>}
      <div className='modalText'>{modalText}</div>
      <div className="buttonsContainer" style={{ marginTop: customMarginTopContainerButtons }}>
        <NudosButton
          buttonText={firstButtonText}
          handleClick={firstButtonAction}
          colorPalette="secondary"
          customClassName="nudosButton"
          isButtonLoading={isLoading}
          isButtonDisabled={isLoading}
        />
        <NudosButton
          buttonText={secondButtonText}
          handleClick={secondButtonAction}
          customClassName="nudosButton"
          isButtonLoading={isLoading}
          isButtonDisabled={isLoading}
        />
      </div>
    </div>
  );
};

export default NudosConfirmActionModalContent;
